import Route from './Route'
import Layout from '@/components/template/Layout'
import Dashboard from '@/views/Dashboard/Base'
import Store from '@/views/Store/Base'
import ListOrders from '@/views/Order/List/Base'
import Logs from '@/views/Log/List'
import OrderDetail from '@/views/Order/Detail/Base'
import Splash from '@/views/Splash/Base'
import ListUsers from '@/views/User/List/Base'
import SecurityConfig from '@/views/Security/Config'

// shared
import ListPresets from '@/views/Preset/List'
import EditPreset from '@/views/Preset/Edit'

// marketplace skyhub
import MarketplaceSkyhubConfiguration from '@/views/Configuration/Skyhub'

// Marketplace WebContinental
import MarketplaceWebContinentalConfiguration from '@/views/Configuration/WebContinental'

// Marketplace Madeira Madeira
import MarketplaceMadeiraConfiguration from '@/views/Configuration/Madeira'

// Marketplace GFG
import MarketplaceGfgConfiguration from '@/views/Configuration/Gfg'

// Marketplace Walmart
import MarketplaceWalmartConfiguration from '@/views/Configuration/Walmart'

// marketplace netshoes
import MarketplaceNetshoesConfiguration from '@/views/Configuration/Netshoes'

// marketplace mercadoLivre
import MarketplaceMercadoLivreConfiguration from '@/views/Configuration/MercadoLivre'

// marketplace shopee
import MarketplaceShopeeConfiguration from '@/views/Configuration/Shopee'

// MarketplaceAnnouncement
import MarketplaceAnnouncementList from '@/views/MarketplaceAnnouncement/List'
import MarketplaceAnnouncement from '@/views/MarketplaceAnnouncement/Announcement'
import MarketplaceAnnouncementEdit from '@/views/MarketplaceAnnouncement/Edit'
import MarketplaceAnnouncementReport from '@/views/MarketplaceAnnouncement/Report'

// AnnouncementMigration
import AnnouncementMigration from '@/views/AnnouncementMigration/Migration'

// Checkout
import AnnouncementMatch from '@/views/AnnouncementMatch/List'

// Marketplace Mercado Livre Tabela de medidas
import MarketplaceSizeGridMercadoLivreList from '@/views/SizeGrid/MercadoLivre/List'
import MarketplaceSizeGridMercadoLivreCreate from '@/views/SizeGrid/MercadoLivre/Create'
import MarketplaceSizeGridMercadoLivreEdit from '@/views/SizeGrid/MercadoLivre/Edit'

// Marketplace Mercado Livre Account
import MarketplaceAccountMercadoLivreList from '@/views/MarketplaceAccount/MercadoLivre/List'
import MarketplaceAccountMercadoLivreEdit from '@/views/MarketplaceAccount/MercadoLivre/Edit'

// Marketplace Shopee Account
import MarketplaceAccountShopeeList from '@/views/MarketplaceAccount/Shopee/List'
import MarketplaceAccountShopeeEdit from '@/views/MarketplaceAccount/Shopee/Edit'

// Marketplace Amazon Account
import MarketplaceAccountAmazonList from '@/views/MarketplaceAccount/Amazon/List'
import MarketplaceAccountAmazonEdit from '@/views/MarketplaceAccount/Amazon/Edit'

// marketplace colombo
import MarketplaceColomboConfiguration from '@/views/Configuration/Colombo'

// marketplace integracommerce
import MarketplaceIntegracommerceConfiguration from '@/views/Configuration/Integracommerce'

// marketplace cnova
import MarketplaceCnovaConfiguration from '@/views/Configuration/Cnova'
import MarketplaceCnovaProductsMatchList from '@/views/ProductMatch/List'
import MarketplaceCnovaProductMigration from '@/views/ProductMigration/Cnova'

// marketplace leroy
import MarketplaceLeroyConfiguration from '@/views/Configuration/Leroy'

// marketplace Carrefour
import MarketplaceCarrefourConfiguration from '@/views/Configuration/Carrefour'

// marketplace Zoom
import MarketplaceZoomConfiguration from '@/views/Configuration/Zoom'

// marketplace Centauro
import MarketplaceCentauroConfiguration from '@/views/Configuration/Centauro'

// marketplace Amazon
import MarketplaceAmazonConfiguration from '@/views/Configuration/Amazon'

// marketplace Ricardo Eletro
import MarketplaceRicardoEletroConfiguration from '@/views/Configuration/RicardoEletro'

// marketplace Renner
import MarketplaceRennerConfiguration from '@/views/Configuration/Renner'

// marketplace Conecta lá
import MarketplaceConectaLaConfiguration from '@/views/Configuration/ConectaLa'

// marketplace Polishop
import MarketplacePolishopConfiguration from '@/views/Configuration/Polishop'

// marketplace Sicoob
import MarketplaceSicoobConfiguration from '@/views/Configuration/Sicoob'

import MarketplacePrivaliaConfiguration from '@/views/Configuration/Privalia'

// marketplace Decathlon
import MarketplaceDecathlonConfiguration from '@/views/Configuration/Decathlon'

// marketplace KeepRunning
import MarketplaceKeepRunningConfiguration from '@/views/Configuration/KeepRunning'

// marketplace Ramarim
import MarketplaceRamarimConfiguration from '@/views/Configuration/Ramarim'

// marketplace Comfortflex
import MarketplaceComfortflexConfiguration from '@/views/Configuration/Comfortflex'

// marketplace Sicredi
import MarketplaceSicrediConfiguration from '@/views/Configuration/Sicredi'

// marketplace MaisCorreios
import MarketplaceMaisCorreiosConfiguration from '@/views/Configuration/MaisCorreios'

// marketplace TikTok Shop
import MarketplaceTikTokShopConfiguration from '@/views/Configuration/TikTokShop'
import MarketplaceAccountTikTokShopList from '@/views/MarketplaceAccount/TikTokShop/List'
import MarketplaceAccountTikTokShopEdit from '@/views/MarketplaceAccount/TikTokShop/Edit'

// marketplace TikTok Shop
import MarketplaceSheinConfiguration from '@/views/Configuration/Shein'
import MarketplaceAccountSheinList from '@/views/MarketplaceAccount/Shein/List'
import MarketplaceAccountSheinEdit from '@/views/MarketplaceAccount/Shein/Edit'

// marketplace Magalu
import MarketplaceMagaluConfiguration from '@/views/Configuration/Magalu'
import MarketplaceAccountMagaluList from '@/views/MarketplaceAccount/Magalu/List'
import MarketplaceAccountMagaluEdit from '@/views/MarketplaceAccount/Magalu/Edit'

// Feed
import FeedList from '@/views/Feed/List/Shared'
import FeedDetail from '@/views/Feed/Detail'

// Product Marketplace
import ProductMarketplaceList from '@/views/ProductMarketplace/List/Shared'
import ProductMarketplaceEdit from '@/views/ProductMarketplace/Edit'

// Error
import NotFound from '@/views/Error/NotFound'
import AccessError from '@/views/Error/AccessError'

// ecommerce moovin
import EcommerceMoovinConfiguration from '@/views/Configuration/Moovin'

// ecommerce oneEg
import EcommerceOneegConfiguration from '@/views/Configuration/Oneeg'

// ecommerce ecomece
import EcommerceEcomeceConfiguration from '@/views/Configuration/Ecomece'

// shipment intelipost
import ShipmentIntelipostConfiguration from '@/views/Configuration/Intelipost'

// shipment frenet
import ShipmentFrenetConfiguration from '@/views/Configuration/Frenet'

// Erp Tiny
import ErpTinyConfiguration from '@/views/Configuration/Tiny'

// Erp Flexy
import ErpFlexyConfiguration from '@/views/Configuration/Flexy'

// tool batch
import ToolBatchTaskList from '@/views/Task/List'
import ToolBatchTaskCreate from '@/views/Task/Create'
import TaskDetail from '@/views/Task/Detail'

// tool api
import ToolApiConfiguration from '@/views/Configuration/Api'
import ToolApiTokens from '@/views/Token/List'
import ToolApiTokenEdit from '@/views/Token/Edit'
import ToolApiTokenCreate from '@/views/Token/Create'
import ToolApiLogs from '@/views/ToolApi/Logs'

// Product Provide
import ProductProvideEdit from '@/views/ProductProvide/Edit'
import ProductProvideList from '@/views/ProductProvide/List'
import ProductProvide from '@/views/ProductProvide/Provide'
import ProductProvideReport from '@/views/ProductProvide/Report'

// Marketplace Attribute
import MarketplaceAttributeList from '@/views/MarketplaceAttribute/List'
import MarketplaceAttributeCreate from '@/views/MarketplaceAttribute/Create'
import MarketplaceAttributeEdit from '@/views/MarketplaceAttribute/Edit'

/**
 * Rotas da aplicação.
 *
 * @type {Route[]}
 */
const routes = [
  new Route(Layout, '/').setChildren([
    new Route(Dashboard, '', 'dashboard'),
    new Route(Store, 'store', 'store'),
    new Route(ListOrders, 'orders', 'orders'),
    new Route(Logs, 'logs', 'logs'),
    new Route(OrderDetail, 'orders/:identifier/:code', 'order'),
    new Route(ListPresets, 'presets', 'presets'),
    new Route(EditPreset, 'presets/:fromType/:fromIdentifier/:toType/:toIdentifier/:type', 'preset'),
    new Route(ListUsers, 'users', 'users'),

    // Marketplace skyhub
    new Route(MarketplaceSkyhubConfiguration, 'marketplace/skyhub/configuration'),

    // Marketplace WebContinental
    new Route(MarketplaceWebContinentalConfiguration, 'marketplace/webcontinental/configuration'),

    // Marketplace Madeira Madeira
    new Route(MarketplaceMadeiraConfiguration, 'marketplace/madeira/configuration'),

    // Marketplace GFG
    new Route(MarketplaceGfgConfiguration, 'marketplace/gfg/configuration'),

    // Marketplace Walmart
    new Route(MarketplaceWalmartConfiguration, 'marketplace/walmart/configuration'),

    // Marketplace netshoes
    new Route(MarketplaceNetshoesConfiguration, 'marketplace/netshoes/configuration'),

    // Marketplace mercado livre
    new Route(MarketplaceMercadoLivreConfiguration, 'marketplace/mercadoLivre/configuration'),

    // Marketplace Shopee
    new Route(MarketplaceShopeeConfiguration, 'marketplace/shopee/configuration'),

    // AnnouncementMigration
    new Route(AnnouncementMigration, 'marketplace/mercadoLivre/announcements/migration'),

    // AnnouncementMatch
    new Route(AnnouncementMatch, 'marketplace/mercadoLivre/announcements/match'),

    // Tabela de medidas Mercado Livre
    new Route(MarketplaceSizeGridMercadoLivreList, 'marketplace/mercadoLivre/sizegrids'),
    new Route(MarketplaceSizeGridMercadoLivreCreate, 'marketplace/mercadoLivre/sizegrids/create'),
    new Route(MarketplaceSizeGridMercadoLivreEdit, 'marketplace/mercadoLivre/sizegrids/:identifier', 'editSizeGrid'),

    // Marketplace Mercado Livre Account
    new Route(MarketplaceAccountMercadoLivreList, 'marketplace/mercadoLivre/accounts'),
    new Route(MarketplaceAccountMercadoLivreEdit, 'marketplace/mercadoLivre/accounts/:identifier'),

    // Marketplace Shopee Account
    new Route(MarketplaceAccountShopeeList, 'marketplace/shopee/accounts'),
    new Route(MarketplaceAccountShopeeEdit, 'marketplace/shopee/accounts/:identifier'),

    // Marketplace Amazon Account
    new Route(MarketplaceAccountAmazonList, 'marketplace/amazon/accounts'),
    new Route(MarketplaceAccountAmazonEdit, 'marketplace/amazon/accounts/:identifier'),

    // Marketplace colombo
    new Route(MarketplaceColomboConfiguration, 'marketplace/colombo/configuration'),

    // Marketplace cnova
    new Route(MarketplaceCnovaConfiguration, 'marketplace/cnova/configuration'),
    new Route(MarketplaceCnovaProductsMatchList, 'marketplace/cnova/products/match'),
    new Route(MarketplaceCnovaProductMigration, 'marketplace/cnova/products/migration'),

    // Marketplace integracommerce
    new Route(MarketplaceIntegracommerceConfiguration, 'marketplace/integracommerce/configuration'),

    // Marketplace leroy
    new Route(MarketplaceLeroyConfiguration, 'marketplace/leroy/configuration'),

    // Marketplace carrefour
    new Route(MarketplaceCarrefourConfiguration, 'marketplace/carrefour/configuration'),

    // Marketplace Zoom
    new Route(MarketplaceZoomConfiguration, 'marketplace/zoom/configuration'),

    // Marketplace Centauro
    new Route(MarketplaceCentauroConfiguration, 'marketplace/centauro/configuration'),

    // Marketplace Amazon
    new Route(MarketplaceAmazonConfiguration, 'marketplace/amazon/configuration'),

    // Marketplace Ricardo Eletro
    new Route(MarketplaceRicardoEletroConfiguration, 'marketplace/ricardoEletro/configuration'),

    new Route(MarketplaceRennerConfiguration, 'marketplace/renner/configuration'),

    new Route(MarketplaceConectaLaConfiguration, 'marketplace/conectaLa/configuration'),

    new Route(MarketplacePolishopConfiguration, 'marketplace/polishop/configuration'),

    new Route(MarketplaceSicoobConfiguration, 'marketplace/sicoob/configuration'),

    new Route(MarketplacePrivaliaConfiguration, 'marketplace/privalia/configuration'),

    new Route(MarketplaceDecathlonConfiguration, 'marketplace/decathlon/configuration'),

    new Route(MarketplaceKeepRunningConfiguration, 'marketplace/keepRunning/configuration'),

    new Route(MarketplaceRamarimConfiguration, 'marketplace/ramarim/configuration'),

    new Route(MarketplaceComfortflexConfiguration, 'marketplace/comfortflex/configuration'),

    new Route(MarketplaceSicrediConfiguration, 'marketplace/sicredi/configuration'),

    new Route(MarketplaceMaisCorreiosConfiguration, 'marketplace/maisCorreios/configuration'),

    new Route(MarketplaceTikTokShopConfiguration, 'marketplace/tikTokShop/configuration'),
    new Route(MarketplaceAccountTikTokShopList, 'marketplace/tikTokShop/accounts'),
    new Route(MarketplaceAccountTikTokShopEdit, 'marketplace/tikTokShop/accounts/:identifier'),

    new Route(MarketplaceSheinConfiguration, 'marketplace/shein/configuration'),
    new Route(MarketplaceAccountSheinList, 'marketplace/shein/accounts'),
    new Route(MarketplaceAccountSheinEdit, 'marketplace/shein/accounts/:identifier'),

    new Route(MarketplaceMagaluConfiguration, 'marketplace/magalu/configuration'),
    new Route(MarketplaceAccountMagaluList, 'marketplace/Magalu/accounts'),
    new Route(MarketplaceAccountMagaluEdit, 'marketplace/Magalu/accounts/:identifier'),

    // Ecommerce moovin
    new Route(EcommerceMoovinConfiguration, 'ecommerce/moovin/configuration'),

    // Ecommerce OneEg
    new Route(EcommerceOneegConfiguration, 'ecommerce/oneeg/configuration'),

    // Ecommerce ecomece
    new Route(EcommerceEcomeceConfiguration, 'ecommerce/ecomece/configuration'),

    // Shipment Intelipost
    new Route(ShipmentIntelipostConfiguration, 'shipment/intelipost/configuration'),

    // Shipment Frenet
    new Route(ShipmentFrenetConfiguration, 'shipment/frenet/configuration'),

    // Erp Tiny
    new Route(ErpTinyConfiguration, 'erp/tiny/configuration'),

    // Erp Flexy
    new Route(ErpFlexyConfiguration, 'erp/flexy/configuration'),

    // Marketplace Attribute
    new Route(MarketplaceAttributeList, 'marketplace/:identifier/attributes'),
    new Route(MarketplaceAttributeCreate, 'marketplace/:identifier/attributes/create'),
    new Route(MarketplaceAttributeEdit, 'marketplace/:identifier/attributes/edit/:attributeId', 'attribute'),

    // Product Marketplace
    new Route(ProductMarketplaceList, 'marketplace/:moduleIdentifier/products'),
    new Route(ProductMarketplaceEdit, 'marketplace/:identifier/products/:sku'),

    // MarketplaceAnnouncement
    new Route(MarketplaceAnnouncementList, 'marketplace/mercadoLivre/Announcements'),
    new Route(MarketplaceAnnouncement, 'marketplace/mercadoLivre/announcement/:fromModuleType/:fromModuleIdentifier'),
    new Route(MarketplaceAnnouncementEdit, 'marketplace/mercadoLivre/announcements/:identifier', 'editAnnouncement'),
    new Route(MarketplaceAnnouncementReport, 'marketplace/mercadoLivre/announcement/report/:fromModuleType/:fromModuleIdentifier'),

    // ProductProvide
    new Route(ProductProvideList, ':moduleType/:moduleIdentifier/products'),
    new Route(ProductProvideEdit, ':type/:identifier/products/:productId'),
    new Route(ProductProvide, ':toModuleType/:toModuleIdentifier/provide/:fromModuleType/:fromModuleIdentifier'),
    new Route(ProductProvideReport, ':toModuleType/:toModuleIdentifier/provide/report/:fromModuleType/:fromModuleIdentifier'),

    // Feed
    new Route(FeedList, ':moduleType/:moduleIdentifier/feeds'),
    new Route(FeedDetail, 'marketplace/:identifier/feeds/detail/:code', 'feed'),

    // Tool batch
    new Route(ToolBatchTaskList, 'tool/batch/tasks'),
    new Route(ToolBatchTaskCreate, 'tool/batch/tasks/create'),
    new Route(TaskDetail, 'tool/batch/tasks/detail/:identifier', 'task'),

    new Route(SecurityConfig, 'security'),

    // Tool api
    new Route(ToolApiConfiguration, 'tool/api/configuration'),
    new Route(ToolApiTokens, 'tool/api/tokens'),
    new Route(ToolApiTokenCreate, 'tool/api/tokens/create'),
    new Route(ToolApiTokenEdit, 'tool/api/tokens/:identifier', 'tokenEdit'),
    new Route(ToolApiLogs, 'tool/api/logs')
  ]),
  new Route(AccessError, '/401'),
  new Route(NotFound, '/404'),
  new Route(Splash, '/authentication'),
  { path: '*', redirect: '/404' }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/routes/index.js